import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import {SuperUserService} from './super-user.service';

@Component({
    selector: 'superuser',
    template: require('./super-user.component.html'),
    host: {
        '(document:click)': 'handleClick($event)',
    },
    providers: [SuperUserService]
})

export class SuperUserComponent implements OnInit {

    public isCollapsed: boolean = true;
    public nNotifications: number = 0;
    notifications: any[];
    notificationsToggle: boolean;
    router: Router;

    constructor(_parentRouter: Router, private _superUserService: SuperUserService) {
        this.router = _parentRouter;
    }

    ngOnInit() {
        this.notificationsToggle = false;
        this._superUserService.getNotifications().then(notifications => { this.notifications = notifications; console.log(notifications); this.nNotifications = notifications.length; });
    }

    public toggleNotifications(): void {        
        if(this.isCollapsed) {
            this.notificationsToggle = !this.notificationsToggle;
        }
        else {
            this.router.navigate(['/superuser', 'notifications', {notificationId:0}]);
            this.isCollapsed=true;
        }
        
    }

    handleClick(event: any) {
        if(this.notificationsToggle && event.srcElement.id!="notification-pop")
            this.notificationsToggle=false;
    }

    public collapse():void  {
        this.isCollapsed=true;
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/super-user.component.ts
 **/